import BodyText from 'LuxKit/Typography/BodyText'
import ListItemLoadingSkeleton from 'LuxKit/List/ListItemLoadingSkeleton'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'

function ChatLandingUpcomingTripsLoading() {
  return (
    <Group direction="vertical" gap={12} fullWidth>
      <BodyText variant="small" weight="bold">
        <TextLoadingBox width="16ch" />
      </BodyText>
      <Sheet border="light-foreground" borderRadius="L">
        <ListItemLoadingSkeleton size="medium" subtitle />
      </Sheet>
    </Group>
  )
}

export default ChatLandingUpcomingTripsLoading
